import { map } from 'lodash/fp';
import { PortableText, Section } from '@ahmdigital/ui';
import generatePortableText from '@ahmdigital/logic/lib/content/utils/generate-portable-text';
import getTerms from '@ahmdigital/logic/lib/content/offers/terms-and-conditions/get-terms';

import placeholderSerializer from '../serializers/placeholder';
import uncapFpIterator from '../../../../utils/uncap-fp-iterator';
import type { Offer, Placeholder } from '../types';

type TermsAndConditionsProps = {
  offer: Offer;
  placeholders: Placeholder[];
  withSmallText?: boolean;
};

const TermsAndConditions = ({ offer, placeholders, withSmallText = false }: TermsAndConditionsProps) =>
  uncapFpIterator(map)(
    // @ts-expect-error - Automatic, Please fix when editing this file
    ({ offerTypeId, content }, index) => (
      <Section
        key={index}
        variant={['paddingTopSpacerNone', withSmallText ? 'paddingBottomSpacer9' : 'paddingBottomSpacer3']}
      >
        <PortableText
          headings={
            withSmallText
              ? {
                  h3: {
                    looksLike: 'h6',
                  },
                }
              : {}
          }
          paragraph={withSmallText ? { variant: 'small' } : undefined}
          key={index}
          typeSerializers={{
            placeholder: placeholderSerializer({ offer, offerTypeId, placeholders }),
          }}
          source={generatePortableText(content)}
        />
      </Section>
    ),
    getTerms(offer),
  );

export default TermsAndConditions;
